var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMgIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: red;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49,0c-1.6,0-2.8,0-1.9,0-11.9,0-22.8,4.3-31.2,11.3-.3.2-.5.5-.8.7,0,0,0,0,0,0-5.6,4.9-10.1,11-13,18.1C.6,34.2,0,37.8,0,42.1c0,.8.2,6.3,3.2,11.7,5.8,10.3,16,13.1,21.7,13.1,11.3-.1,24.6-5.7,35.7-15.9,0,0-1.4,8.1-1.9,10.6-.4,2.4,1.2,4.5,3.6,4.6h1c2.5,0,4.3-2,4.7-4.6l4-22.6c.5-2.5-1.2-4.5-3.7-4.5h-22.6c-2.5,0-4.8,1.3-5.3,3.9,0,.1-.2.9-.2,1-.4,2.4,1.3,4.2,3.7,4.2h11.8c-.2.2-.4.4-.6.6-8.1,7.7-18.2,11.9-26.5,11.9s-17.3-5.3-17.6-17.1c0-3.5.6-5.3,1.1-6.9,4.8-14.2,23.2-22.1,36.7-21.7,22.5.6,39.4,18.9,39.4,41.4s-20.8,41.4-43.3,41.4c-22.7,0-34.3-11.4-40.3-20.9-3.7-5.9-3.8-3.1-1.8,1,8.2,17.1,25.7,28.9,45.9,28.9s51-22.9,51-51S77.1,0,49,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMgIconRed);
export default __webpack_public_path__ + "static/media/MG_IconRed.3bf8f1b728a0c4287a98f1a476c21e5d.svg";
export { ForwardRef as ReactComponent };